$(document).ready(function () {
  // Benefit Section Js
  $(".benefits_nav_block ul li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(".benefits_nav_block ul li").removeClass("current");
    $(".benefits_content_block").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
  
  // Benefit Section Js
  $(".carlson_product_tab_nav li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(".carlson_product_tab_nav li").removeClass("current");
    $(".carlson_product_tab_content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
  
  // $('.frequently_ask_acc_container .frequently_ask_acc:nth-child(1) .frequently_ask_acc_head').addClass('active');
  // $('.frequently_ask_acc_container .frequently_ask_acc:nth-child(1) .frequently_ask_acc_content').slideDown();
  $('.frequently_ask_acc_head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.frequently_ask_acc_content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.frequently_ask_acc_content').slideUp();
        $('.frequently_ask_acc_head').removeClass('active');
        $(this).siblings('.frequently_ask_acc_content').slideToggle();
        $(this).toggleClass('active');
      }
  });

  $(".carlson_founded_btn").click(function(){
     $(this).parent(".carlson_founded_video_btn").find(".carlson_founded_video_block").addClass("Video_show");
     $("body").addClass("Video_pop_up_show");
  });
  $(".carlson_founded_video_close").click(function(){
      $(this).parents(".carlson_founded_video_block").removeClass("Video_show");
      $("body").removeClass("Video_pop_up_show");
  });
  $(".review_top_slide").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    variableWidth: true,
    autoplay: true,
    speed: 8000,
    cssEase: "linear",
    rtl: true,
    pauseOnHover: false,
    dots: false,
    arrows: false,
  });
  $(".review_bottom_slider").slick({
    slidesToShow: 3.65,
    infinite: true,
    pauseOnHover: false,
    slidesToScroll: 1,
    autoplay: true,
    speed: 8000,
    cssEase: "linear",
    dots: false,
    arrows: false,
     responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.5,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
  });
  
  $('.backed_experts_info_slider').slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.backed_experts_logo_slider'
  });
  $('.backed_experts_logo_slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.backed_experts_info_slider',
    dots: false,
    focusOnSelect: true,
    arrows: true,
    centerMode: true,
    centerPadding: '200px',
    appendArrows: $(".backed_experts_arrow"),
    prevArrow: '<button><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.778" d="M22.667 12H1.333m0 0s3.41-.863 5.167-1.905c1.757-1.041 3.833-3.428 3.833-3.428m-9 5.333s3.41.863 5.167 1.905c1.757 1.041 3.833 3.428 3.833 3.428"/></svg></button>',
    nextArrow: '<button><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.778" d="M1.333 12h21.334m0 0s-3.41-.863-5.167-1.905c-1.757-1.041-3.833-3.428-3.833-3.428m9 5.333s-3.41.863-5.167 1.905c-1.757 1.041-3.833 3.428-3.833 3.428"/></svg></button>',
     responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      }
    },
       {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
      }
    },
        {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
  });
  $('.carlson_plant_base_products_slider').slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    centerMode: true,
    centerPadding: '110px',
    arrows: true,
    prevArrow: '<button class="slick-arrow slick-prev"><svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L1.5 6L8 11" stroke="#6A6C77" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L8 6L1.5 11" stroke="#6A6C77" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
     responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
          centerPadding: '100px'
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
         centerPadding: '80px'
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
          centerPadding: '100px'
      }
    },
        {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
          centerPadding: '80px'
      }
    },
         {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
          centerPadding: '60px'
      }
    }
  ]
  });

    $('.carlson_bone_health_slider').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    prevArrow: '<button class="slick-arrow slick-prev"><svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L1.5 6L8 11" stroke="#6A6C77" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L8 6L1.5 11" stroke="#6A6C77" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
     responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    },
        {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
         {
      breakpoint: 576,
      settings: {
        slidesToShow: 2
      }
    }
  ]
  });
});


